import axios from 'axios';
import Cookies from 'js-cookie';

export const getAlertsData = (path = '', params = {}, signal) => axios.get(
    `${import.meta.env.VITE_BASEURL}/get/alerts${path}`,
    { params, signal, timeout: 30000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);

// Manual access to the shared backend evaluation service; never replay uncertain writes.
export const processRPMTempAlert = body => axios.post(
    `${import.meta.env.VITE_BASEURL}/post/alerts/rpm-temp/process`, body,
    { timeout: 60000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);
